import { render, staticRenderFns } from "./TradeInQcModal.vue?vue&type=template&id=475d6e3c"
import script from "./TradeInQcModal.vue?vue&type=script&lang=js"
export * from "./TradeInQcModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports